import { Children, useMemo, useContext, createContext, createElement, cloneElement } from "react";
import { mergeProps } from "./mergeProps.es.js";
const SlotContext = createContext(null);
function useSlotProps(props, defaultSlot) {
  const slot = props.slot || defaultSlot;
  const { [slot]: slotProps = {} } = useContext(SlotContext) || {};
  return mergeProps(slotProps, props);
}
function SlotProvider(props) {
  const fallbackSlots = useMemo(() => ({}), []);
  const parentSlots = useContext(SlotContext) || fallbackSlots;
  const { slots = {}, children } = props;
  const value = useMemo(
    () => Object.keys(parentSlots).concat(Object.keys(slots)).reduce(
      (o, p) => ({
        ...o,
        [p]: mergeProps(parentSlots[p] || {}, slots[p] || {})
      }),
      {}
    ),
    [parentSlots, slots]
  );
  return createElement(SlotContext.Provider, { value }, children);
}
function ClearSlots(props) {
  const { children, ...otherProps } = props;
  const content = (
    // need to know if the node is a string or something else that react can render that doesn't get props
    Children.toArray(children).length <= 1 && typeof children === "function" ? cloneElement(Children.only(children), otherProps) : children
  );
  return createElement(SlotContext.Provider, { value: {} }, content);
}
const containsChild = (children, type) => Children.toArray(children).some((child) => {
  var _a;
  return ((_a = child.type) == null ? void 0 : _a.displayName) === type;
});
const hasContentSlot = (children) => containsChild(children, "EzContent");
export {
  ClearSlots,
  SlotProvider,
  containsChild,
  hasContentSlot,
  useSlotProps
};
//# sourceMappingURL=slots.es.js.map
